import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { ApiResultModel } from "../../models/common.model";
import {
  GetProductsCategoryRequest,
  GetProductsCategoryResponse,
} from "../models/store.model";
import { GetProductCategory } from "../service/store.service";
import Header from "./header";
import { useHistory } from "react-router-dom";
import {
  PARENT_CATEGORY_ID,
  PARENT_CATEGORY_ID_OLD,
  PRODUCT_KEY,
} from "../../config/cacheKey";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CategorySkeleton from "./categorySkeleton";

export default function ProductCategoryCard() {
  const history = useHistory<{
    parentCategoryId: number;
    title: string;
    path?: any[];
  }>();
  const queryClient = useQueryClient();
  useEffect(() => {
    const productsRequest = {} as GetProductsCategoryRequest;
    if (history.action === "POP") {
      productsRequest.parentCategoryId = Number(
        sessionStorage.getItem(PARENT_CATEGORY_ID_OLD)
      );
    } else if (history.action === "PUSH" || history.action === "REPLACE") {
      productsRequest.parentCategoryId = history.location.state
        ?.parentCategoryId
        ? history.location.state.parentCategoryId
        : Number(sessionStorage.getItem(PARENT_CATEGORY_ID));
    }

    getProductCategory(productsRequest);
    sessionStorage.setItem(PRODUCT_KEY, "");
  }, [history.location?.state?.parentCategoryId]);

  const [data, setData] = useState<GetProductsCategoryResponse>();

  const { mutate: getProductCategory, isLoading } = useMutation(
    GetProductCategory,
    {
      onSuccess: (result: ApiResultModel<GetProductsCategoryResponse>) => {
        if (result.data != null) {
          setData(result.data);
          sessionStorage.setItem(PARENT_CATEGORY_ID_OLD, String(data?.id));
          history.replace({
            state: {
              parentCategoryId: result.data!.id,
              title: result.data!.title,
              path: result.data.categoryPath,
            },
          });
        } else {
          history.push({
            pathname: "/products/productCategory1/ProductList",
            state: {
              parentCategoryId: history.location.state?.parentCategoryId
                ? history.location.state.parentCategoryId
                : Number(sessionStorage.getItem(PARENT_CATEGORY_ID)),
              title: history.location.state?.title,
              path: history.location.state?.path,
            },
          });
        }
      },
    }
  );

  function selectProductCategoury(
    id: number,
    hasChildCategory: boolean,
    hasProduct: boolean,
    title: string
  ) {
    const productsRequest = {} as GetProductsCategoryRequest;
    productsRequest.parentCategoryId = id;
    sessionStorage.setItem(PARENT_CATEGORY_ID, String(id));
    if (hasProduct) {
      sessionStorage.setItem(PARENT_CATEGORY_ID_OLD, String(data?.id));
      history.push({
        pathname: "/products/productCategory1/ProductList",
        state: {
          parentCategoryId: id,
          title,
        },
      });
    } else if (hasChildCategory) {
      history.push(
        `/products/productCategory1/productCategoryCard/${data?.id}`
      );
      getProductCategory(productsRequest);
    } else {
      toast.info("اطلاعاتی یافت نشد");
    }
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container>
        <Grid item xs={12}>
          <Header
            search={true}
            category={true}
            parentCategoryId={
              history.location.state?.parentCategoryId
                ? history.location.state?.parentCategoryId
                : 0
            }
          />
        </Grid>
        {data?.bannerData ? (
          <Grid
            item
            xs={12}
            style={{ marginTop: "10px", marginBottom: "70px" }}
          >
            <img
              style={{ width: "100%" }}
              className="classCenter objectFit"
              src={`data:image/png;base64,${data?.bannerData}`}
              alt="طرح "
            />
          </Grid>
        ) : (
          <Grid item style={{ marginTop: "40px" }} xs={12}></Grid>
        )}
        {!isLoading ? (
          <Grid container xs={12} spacing={4}>
            {data?.items.map((item: any) => (
              <Grid item xs={4} sm={2}>
                <div
                  onClick={() =>
                    selectProductCategoury(
                      item.id,
                      item.hasChildCategory,
                      item.hasProduct,
                      item.title
                    )
                  }
                  className="cursorPointer"
                >
                  <img
                    style={{ width: "100%", height: "85%" }}
                    className="classCenter objectFit"
                    src={`data:image/png;base64,${item.imageData}`}
                    alt="طرح "
                  />
                  <span
                    style={{
                      textAlign: "center",
                      display: "grid",
                      top: "25px",
                      position: "relative",
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "#0D47A1",
                    }}
                  >
                    {item.title}
                  </span>
                </div>
              </Grid>
            ))}
          </Grid>
        ) : (
          <CategorySkeleton child={true} />
        )}
      </Grid>
    </Box>
  );
}
